export var animationDuration = '0.3s';
export var slideUpThreshold = 20;
export var closeThreshold = 0.3;
